/**
 * ============================================================================
 * СЕРВИС КУРСОВ
 * ============================================================================
 * Методы для работы с курсами
 * ============================================================================
 */

import api from './api'
import { compressImage, shouldCompress } from '@/utils/imageCompression'

let teacherCoursesRequest = null

export const coursesService = {
	/**
	 * Получить все курсы
	 */
	async getAll() {
		const response = await api.get('/courses')
		return response?.data ?? response
	},

	async getMy() {
		console.log('🔍 [coursesService.getMy] Отправляем запрос...')

		const response = await api.get('/courses/my')

		console.log('🔍 [coursesService.getMy] response:', response)
		console.log('🔍 [coursesService.getMy] response.data:', response?.data)

		// ИСПРАВЛЕНО: нужно брать response.data как в других методах
		const data = response?.data ?? response

		// Возвращаем массив курсов
		return Array.isArray(data) ? data : data?.courses || []
	},

	/**
	 * Получить курс по ID
	 */
	async getById(id) {
		const response = await api.get(`/courses/${id}`)
		return response?.data ?? response
	},

	/**
	 * Создать новый курс
	 */
	async create(courseData) {
		const response = await api.post('/courses', courseData)
		return response?.data ?? response
	},

	/**
	 * Обновить курс
	 */
	async update(id, courseData) {
		const response = await api.put(`/courses/${id}`, courseData)
		return response?.data ?? response
	},

	/**
	 * Удалить курс
	 */
	async delete(id) {
		const response = await api.delete(`/courses/${id}`)
		return response?.data ?? response
	},

	/**
	 * Опубликовать курс
	 */
	async publish(id) {
		const response = await api.post(`/courses/${id}/publish`)
		return response?.data ?? response
	},

	/**
	 * Снять с публикации
	 */
	async unpublish(id) {
		const response = await api.post(`/courses/${id}/unpublish`)
		return response.data
	},

	/**
	 * Записать студента на курс
	 * studentId автоматически берется из JWT токена на backend
	 */
	async enroll(courseId) {
		const response = await api.post(`/courses/${courseId}/enroll`)
		return response?.data ?? response
	},

	/**
	 * Поставить курс на паузу (для студента)
	 */
	async pauseEnrollment(courseId) {
		const response = await api.patch(`/courses/${courseId}/pause`)
		return response?.data ?? response
	},

	/**
	 * Снять курс с паузы (для студента)
	 */
	async resumeEnrollment(courseId) {
		const response = await api.patch(`/courses/${courseId}/resume`)
		return response?.data ?? response
	},

	/**
	 * Отписать студента от курса
	 */
	async unenroll(courseId, studentId) {
		const response = await api.post(`/courses/${courseId}/unenroll`, {
			studentId,
		})
		return response?.data ?? response
	},

	/**
	 * Получить студентов курса
	 */
	async getStudents(courseId) {
		const response = await api.get(`/courses/${courseId}/students`)
		return response?.data ?? response
	},

	/**
	 * Получить курсы преподавателя
	 */
	async getTeacherCourses() {
		if (!teacherCoursesRequest) {
			teacherCoursesRequest = (async () => {
				const response = await api.get('/courses/teacher/my/courses')
				const data = response?.data ?? response
				return data?.courses || data
			})().finally(() => {
				teacherCoursesRequest = null
			})
		}

		return teacherCoursesRequest
	},

	/**
	 * Получить курсы преподавателя с мета-данными
	 */
	async getTeacherCoursesWithMeta() {
		const response = await api.get('/courses/teacher/my/courses')
		return response?.data ?? response
	},

	/**
	 * Загрузить обложку курса
	 */
	async uploadCover(courseId, file) {
		// Сжимаем изображение если оно больше 1MB
		let fileToUpload = file
		if (shouldCompress(file, 1)) {
			console.log(`🗜️ Сжатие изображения: ${(file.size / 1024 / 1024).toFixed(2)}MB`)
			fileToUpload = await compressImage(file, {
				maxWidth: 1920,
				maxHeight: 1080,
				quality: 0.85,
				maxSizeMB: 1,
			})
			console.log(`✅ Сжато до: ${(fileToUpload.size / 1024 / 1024).toFixed(2)}MB`)
		}

		const formData = new FormData()
		formData.append('cover', fileToUpload)

		const response = await api.post(`/courses/${courseId}/cover`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
		return response?.data ?? response
	},

	/**
	 * Загрузить демо видео или презентацию курса
	 */
	async uploadDemoMedia(courseId, file) {
		const formData = new FormData()
		formData.append('demo_media', file)

		const response = await api.post(
			`/courses/${courseId}/demo-media`,
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}
		)
		return response?.data ?? response
	},

	/**
	 * Изменить видимость курса (скрыть/показать)
	 */
	async toggleVisibility(courseId, isHidden) {
		const response = await api.patch(`/courses/${courseId}/visibility`, {
			is_hidden: isHidden,
		})
		return response?.data ?? response
	},

	/**
	 * Изменить видимость курса (скрыть/показать)
	 */
	async toggleVisibility(courseId, isHidden) {
		const response = await api.patch(`/courses/${courseId}/visibility`, {
			is_hidden: isHidden,
		})
		return response?.data ?? response
	},
}

export default coursesService
